import { FC } from 'react';
import { Grid, IconButton } from '@material-ui/core';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
import Participant from '../Participant';
import userIcon from '../../../../assets/streaming/actions/user-white.svg';
import finishIcon from '../../../../assets/streaming/actions/exit-to-app.svg';
import DisconnectDialog from '../DisconnectDialog';
import useStreamingLogic from '../hooks/useStreamingLogic';
import DominantSpeakerOverlay from '../DominantSpeakerOverlay';

const MobileVideoLayout: FC = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const {
        openDisconnectModal,
        disconnectEvent,
        closeEvent,
        setOpenDisconnectModal,
        leaveEvent,
        participants,
        mainParticipant,
        influencerUsername,
        remoteParticipant,
        localUserUsername,
    } = useStreamingLogic();

    return (
        <Grid container xs={12} justify="center" alignContent="center" alignItems="center" direction="row">
            <DisconnectDialog
                open={openDisconnectModal}
                onLeaveNotFinishing={disconnectEvent}
                onLeaveFinishingEvent={closeEvent}
                onDismiss={() => setOpenDisconnectModal(false)}
            />
            <div className={classes.userCounter}>
                <img src={userIcon} alt={t('Viewer counter')} /> {participants.length}
            </div>
            <IconButton className={classes.exitButton} onClick={leaveEvent}>
                <img src={finishIcon} alt={t('Finish event')} />
            </IconButton>
            <DominantSpeakerOverlay mobileLayout />
            <Grid container item xs={12} direction="row" className={clsx(classes.container)}>
                <Grid
                    xs={12}
                    container
                    justify="flex-start"
                    alignContent="center"
                    alignItems="center"
                    direction="row"
                >
                    {mainParticipant && (
                        <Participant
                            key={mainParticipant.sid}
                            participant={mainParticipant}
                            enableScreenShare
                            isLocalParticipant
                        />
                    )}
                </Grid>
                <Grid
                    xs={1}
                    container
                    justify="flex-start"
                    alignContent="center"
                    alignItems="center"
                    direction="row"
                    className={classes.audioPlayer}
                >
                    {participants
                        .filter(participant => participant.identity !== influencerUsername)
                        .map(participant => {
                            return (
                                <Participant key={participant.sid + Date.now()} participant={participant} />
                            );
                        })}
                </Grid>
                <Grid
                    xs={12}
                    container
                    justify="flex-start"
                    alignContent="center"
                    alignItems="center"
                    direction="row"
                    className={classes.remoteVideo}
                >
                    {remoteParticipant && (
                        <Participant
                            key={remoteParticipant.sid}
                            participant={remoteParticipant}
                            isLocalParticipant={remoteParticipant.identity === localUserUsername}
                        />
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default MobileVideoLayout;
